import React from 'react';

const PartnerSupport = () => {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Partner & Support</h1>
      <p>Discover our partnership opportunities and support services.</p>
    </div>
  );
};

export default PartnerSupport;
